export default __webpack_public_path__ + "static/swiggy-eb21103ef44c32d26c05a98bd444f97b.svg";